import PropTypes from 'prop-types';
import usePageDisplayNameClass from 'src/universal/hooks/usePageDisplayNameClass';

const SetDisplayNameClass = ({ displayName = 'iNav-us' }) => {
  usePageDisplayNameClass(displayName);
  return null;
};

SetDisplayNameClass.propTypes = {
  displayName: PropTypes.string
};

export default SetDisplayNameClass;
